import React from "react";
import { Box, Stack, Typography, Dialog, DialogContent, IconButton } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { IoClose } from "react-icons/io5";
import { useTheme, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { T } from "../../constants/todoTokens";
import FullTaskCard from "./FullTaskCard";

const DayDetailModal = ({ open, date, tasks, onClose, onTaskClick, onArchive, onDelete, isAdmin, currentUserId, onAssigneeStatusChanged }) => {
  const theme    = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!date) return null;

  const todayKey = dayjs().format("YYYY-MM-DD");
  const isToday  = date.format("YYYY-MM-DD") === todayKey;
  const fullDate = date.format("dddd, MMMM D, YYYY");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={isMobile}
      TransitionProps={{ timeout: 220 }}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : "20px",
          boxShadow: T.shadow.lg,
          overflow: "hidden",
          m: isMobile ? 0 : 2,
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 3, pt: 3, pb: 2.5,
          background: `linear-gradient(135deg, ${T.primary} 0%, ${T.primaryDark} 100%)`,
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            {isToday && (
              <Typography
                sx={{
                  fontSize: "10px", fontWeight: 800, letterSpacing: "0.1em",
                  color: "rgba(255,255,255,0.65)", textTransform: "uppercase", mb: 0.4,
                }}
              >
                Today
              </Typography>
            )}
            <Typography sx={{ fontSize: "19px", fontWeight: 800, color: "#fff", lineHeight: 1.2 }}>
              {fullDate}
            </Typography>
            <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", mt: 0.6, fontWeight: 500 }}>
              {tasks.length} task{tasks.length !== 1 ? "s" : ""}
            </Typography>
          </Box>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ color: "rgba(255,255,255,0.8)", mt: -0.5, "&:hover": { bgcolor: "rgba(255,255,255,0.12)" } }}
          >
            <IoClose size={20} />
          </IconButton>
        </Stack>
      </Box>

      {/* Task list */}
      <DialogContent sx={{ p: 2, bgcolor: T.bg, maxHeight: isMobile ? "80vh" : 480, overflowY: "auto" }}>
        <Stack spacing={1.5}>
          <AnimatePresence>
            {tasks.map((task, i) => (
              <FullTaskCard
                key={task._id}
                task={task}
                index={i}
                onClick={(t) => { onClose(); onTaskClick(t); }}
                onArchive={onArchive}
                onDelete={onDelete}
                isAdmin={isAdmin}
                currentUserId={currentUserId}
                onAssigneeStatusChanged={onAssigneeStatusChanged}
              />
            ))}
          </AnimatePresence>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(DayDetailModal);
